import { atom } from 'infrastructure/state/jotai.wrapper'
import { IVersionUpdateData } from '../MasterIdSelection'
import { hasMasterUpdateValidationErrors } from '../../../masters_management/utility'

export const selectedUpdatesAtom = atom<IVersionUpdateData[]>([])

export const exceptionsAtom = atom<string[]>([])

export const containsValidationErrorsAtom = atom((get) => {
  const updates = get(selectedUpdatesAtom)
  const exceptions = get(exceptionsAtom)
  return !!updates.find((update) => {
    return (
      !exceptions.includes(update.treeId) &&
      hasMasterUpdateValidationErrors(update.validations)
    )
  })
})
